import { render } from "./WarehouseDatatableFormKitMaterials.vue?vue&type=template&id=234b7737"
import script from "./WarehouseDatatableFormKitMaterials.vue?vue&type=script&lang=js"
export * from "./WarehouseDatatableFormKitMaterials.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__